module.exports = __webpack_public_path__ + "img/pay_money@2x.63e83f05.png";